// Module
var code = "<users></users>\n";
// Exports
module.exports = code;